import { navBadgeId, type NavBadgeKey, type NavItem } from './nav';

const NAV_BADGE_NOUN: Record<NavBadgeKey, string> = {
  pendingLeave: 'pending requests',
  unreadNotifications: 'unread notifications',
};

/**
 * The count is decoration for sighted users: it is `aria-hidden` so the link's accessible *name* stays
 * exactly the label ("Leave", not "Leave 3"). Screen readers still get it as the link's *description*
 * (`aria-describedby` on the link points at the `hidden` text; a described-by target may be hidden).
 */
export function NavBadge({ item, badges }: { item: NavItem; badges: Partial<Record<NonNullable<NavItem['badge']>, number>> }) {
  const n = item.badge ? badges[item.badge] : undefined;
  if (!item.badge || !n) return null;
  return (
    <>
      <span
        aria-hidden="true"
        className="rounded-full bg-accent-soft px-1.5 font-mono text-[10px] font-semibold tabular-nums text-accent-fg"
      >
        {n}
      </span>
      <span id={navBadgeId(item)} hidden>
        {n} {NAV_BADGE_NOUN[item.badge]}
      </span>
    </>
  );
}
